import $ from 'jquery'
import Splide from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import {lockBody, unlockBody} from "../utils";

$('.js-other-places-slider').each(function() {
    var $this = $(this);
    var placesSplide = new Splide( $this[0], {
        drag   : 'free',
        arrows: false,
        pagination: false,
        perPage: 4,
        autoHeight: true,
        gap : '30px',
        breakpoints: {
            992: {
                perPage: 3,
            },
            768: {
                fixedWidth : '210px',
                perPage: 1,
            },
        }
    });

    placesSplide.mount();
});

$('.js-reviews-slider').each(function() {
    var $this = $(this);
    var reviewsSplide = new Splide( $this[0], {
        type: 'loop',
        drag   : 'free',
        arrows: false,
        pagination: false,
        perPage: 3,
        autoHeight: true,
        gap : '30px',
        autoScroll: {
            speed: .3,
        },
        breakpoints: {
            1190: {
                perPage: 2,
            },
            600: {
                perPage: 1,
            },
        }
    });

    reviewsSplide.mount({ AutoScroll });
});

const el = $('.youtube-video-iframe')
const overlayEl = $('.js-video-overlay')
const ytId = el.attr('data-id')

overlayEl.on('click', function () {
    overlayEl.remove()
    $('.js-video-thumbnail').css('display', 'none')
    el.replaceWith(`<iframe src="https://www.youtube-nocookie.com/embed/${ytId}?autoplay=1" allow="autoplay">`)
    var video = $('.s-place__video').find('video')
    video[0].play();
})


function moveDescription() {
    var screenWidth = $(window).width();
    var $deskElement = $('.js-short-desc-desk');
    var $mobElement = $('.js-short-desc-mob');

    if (screenWidth < 992) {
        if ($deskElement.length && !$deskElement.data('moved')) {
            $mobElement.append($deskElement.html());
            $deskElement.data('moved', true);
        }
    } else {
        if ($deskElement.length && $deskElement.data('moved')) {
            $deskElement.html($mobElement.html());
            $mobElement.empty();
            $deskElement.data('moved', false);
        }
    }
}
moveDescription();
$(window).resize(function() {
    moveDescription();
});

$('.js-open-mobile-schedule').on('click', function() {
    if ( $(this).hasClass('is-open') ) {
        closeMobileInfos()
    }
    else {
        openMobileInfos()
    }
})

$('.js-close-mobile-schedule').on('click', function() {
    closeMobileInfos()
})

function openMobileInfos() {
    $('.js-mobile-infos').slideDown()
    $('.js-info-btn').html($('.js-info-btn').data('open-text'))
    $('.js-info-btn').addClass('is-open')
    $('.js-fixed-overlay').addClass('is-open')
    $('body').addClass('info-open').css('overflow', 'hidden')
    lockBody()
}

function closeMobileInfos() {
    $('.js-mobile-infos').slideUp()
    $('.js-info-btn').html($('.js-info-btn').data('closed-text'))
    $('.js-info-btn').removeClass('is-open')
    $('.js-fixed-overlay').removeClass('is-open')
    $('body').removeClass('info-open')
    unlockBody()
}


$('.js-toggle-schedule').on('click', function () {
    if ($(window).width() > 992) {
        if ( ! $(this).hasClass('open')) {
            $(this).parent().find('.js-schedule').addClass('s-place__schedule--active')
            $(this).addClass('open')
            $(this).html($(this).data('open-text'))
        }
        else {
            $(this).parent().find('.js-schedule').removeClass('s-place__schedule--active')
            $(this).removeClass('open')
            $(this).html($(this).data('closed-text'))
        }
    }
    else {
        openMobileInfos()
    }
})